// measured average onset latency of Tone.PitchShift at windowSize 0.03
// (pitched hits exit the sawtooth-modulated delay lines late; scheduling
// them early by the mean centers them on the grid)
export const pitchLatency: Record<string, number> = {
    hi: 0.0095,
}

// 'lo' skips the PitchShift (it smeared badly pitching down) and instead just
// plays the buffer at half rate — an octave down, halftime
export const pitchRates: Record<string, number> = {
    lo: 0.5,
}

export const defaults = {
    slices: [
        0, 1, 2, 3,
        4, 5, 6, 7,
        8, 9, 10, 11,
        12, 13, 14, 15,
    ],
    samples: [
        0, 0, 0, 0,
        0, 0, 0, 0,
        0, 0, 0, 0,
        0, 0, 0, 0,
    ],
    retrigs: [
        0, 0, 0, 0,
        0, 0, 0, 0,
        0, 0, 0, 0,
        0, 0, 0, 0,
    ],
    playerTypes: [
        'normal', 'normal', 'normal', 'normal',
        'normal', 'normal', 'normal', 'normal',
        'normal', 'normal', 'normal', 'normal',
        'normal', 'normal', 'normal', 'normal',
    ],
    locks: [
        false, false, false, false,
    ],
}
